import { gql } from 'urql';

export default gql`
  mutation RemoveExternalAccount($idempotencyId: String!, $id: ID!) {
    removeExternalAccount(idempotencyId: $idempotencyId, id: $id)
  }
`;
